import { forwardRef, type ReactNode } from 'react'
import { cn } from '../utils/cn.ts'

export interface InfoRowProps {
  icon: ReactNode
  iconBackground?: string
  primary: string
  secondary?: string
  className?: string
}

export const InfoRow = forwardRef<HTMLDivElement, InfoRowProps>(
  ({ icon, iconBackground, primary, secondary, className }, ref) => {
    return (
      <div ref={ref} className={cn('info-row', className)}>
        <div
          className="info-row-icon"
          style={iconBackground ? { backgroundColor: iconBackground } : undefined}
        >
          {icon}
        </div>
        <div className="info-row-text">
          <span className="info-row-primary">{primary}</span>
          {secondary && <span className="info-row-secondary">{secondary}</span>}
        </div>
      </div>
    )
  },
)

InfoRow.displayName = 'InfoRow'
